import { render } from "./SimpleLine.vue?vue&type=template&id=299413bd&scoped=true"
const script = {}

import "./SimpleLine.vue?vue&type=style&index=0&id=299413bd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-299413bd"

export default script